module.exports = __webpack_public_path__ + "static/media/arrow-left.ea3e6800.svg";